import clsx from 'clsx'
import Image from 'next/image'

interface Props {
  className?: string
}

const TranslationIcon = ({className}: Props) => {
  return (
    <Image
      width={24}
      height={24}
      className={clsx(className)}
      src='https://static.gamezop.com/comet/assets/img2/language-switch.svg'
      alt='translate icon'
    />
  )
}

export default TranslationIcon
